import React, { PureComponent } from 'react'
import CSSModules from 'react-css-modules'
import classNames from 'classnames'

import { Pair, PairHolder } from '../../components'
import styles from './teacher_grid.scss'

class TeacherGrid extends PureComponent {

	editPairHandler = id => {
		const pair_data = this.props.pairs.find(item => item.id === id)
		this.props.editPairHandler(pair_data)
	}

	render() {
		return (
			<ul styleName={classNames({
				wrapper: true,
				'wrapper--empty': this.props.pairs.length === 0,
			})}>
				{
					this.props.pairs.map(pair => (
						<li styleName='item' key={pair.id}>
							<Pair
								id={pair.id}
								card1={{
									type: pair.card1.type,
									value: pair.card1.type === 'image' ? pair.card1.value.icon.versions.crop : pair.card1.value,
								}}
								card2={{
									type: pair.card2.type,
									value: pair.card2.type === 'image' ? pair.card2.value.icon.versions.crop : pair.card2.value,
								}}
								selectPairHandler={this.editPairHandler}
							/>
						</li>
					))
				}
				{ (this.props.pairs.length < 12 && this.props.presentationId) &&
					<li styleName='item'>
						<PairHolder
							error={this.props.minPairsError}
							addPairHandler={this.props.addPairHandler}
							size={this.props.pairs.length === 0 ? 'big' : 'normal'}
						/>
					</li>
				}
			</ul>
		)
	}
}

export default CSSModules(TeacherGrid, styles, { allowMultiple: true })
